export default {
  authenticated: () => import("/usr/src/app/layouts/authenticated.vue"),
  default: () => import("/usr/src/app/layouts/default.vue")
}